
const socketEvents={
    CONNECT : 'connection',
    DISCONNECT : 'disconnect',
  
    SUBSCRIBE_TO_CHANNEL : 'subscribe-to-channel',
    UNSUBSCRIBE_TO_CHANNEL : 'unsubscribe-to-channel',
    SEND_MESSAGE : 'send-message',
    GET_MESSAGE : 'get-message',
  
    SUBSCRIBE_TO_THREAD : 'subscribe-to-thread',
    UNSUBSCRIBE_TO_THREAD : 'unsubscribe-to-thread',
    SEND_THREAD_MESSAGE : 'send-thread-message',
    GET_THREAD_MESSAGE : 'get-thread-message',

    ADD_REACTION : 'add-reaction',
    LOGOUT : 'logout',
    MESSAGE_CREATION_FAILED : 'message-creation-failed',
    USERTYPING : 'user-typing'
  };

export default socketEvents;